// Frames.js — molduras das capturas do PsicoID: celular (telas do app) e navegador (painel web).
import React from 'react';

/** Moldura de celular. A captura já traz a barra de status; aqui entram só o corpo e a ilha. */
export function PhoneFrame({ src, alt = '', eager = false, className = '', children }) {
  return (
    <div className={`pid-phone ${className}`}>
      <div className="pid-phone-screen">
        {children || (
          <img src={src} alt={alt} width="600" height="1298" loading={eager ? 'eager' : 'lazy'} decoding="async" />
        )}
      </div>
      <span className="pid-phone-island" aria-hidden />
    </div>
  );
}

/** Moldura de janela de navegador, com a URL da tela na barra. */
export function BrowserFrame({ src, alt = '', url = 'psicoid.com.br', eager = false, className = '', children }) {
  return (
    <div className={`pid-browser ${className}`}>
      <div className="pid-browser-bar" aria-hidden>
        <span className="pid-browser-dot" />
        <span className="pid-browser-dot" />
        <span className="pid-browser-dot" />
        <div className="pid-browser-url">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span>{url}</span>
        </div>
      </div>
      <div className="pid-browser-screen">
        {children || (
          <img src={src} alt={alt} width="1600" height="1000" loading={eager ? 'eager' : 'lazy'} decoding="async" />
        )}
      </div>
    </div>
  );
}
